'use client'
import { Badge, Box, Card, Flex, Text, Button, UnstyledButton } from '@mantine/core'
import { useContext } from 'react'

import { ConnectButton } from '../common/ConnectButton'
import {
  desktopProfileCard,
  desktopProfileCardHeader,
  desktopProfileCardTitle,
  proBadgeLabel,
  profileCardCarouselWrapper,
} from './styles.css'

import { IdentityContext, ImagesCarousel, PeerAccountContext, SafeAvatarImage, useAppAuth } from '~/app/_components'
import { accountProfessions, accountType } from '~/utils'
import { AccountTier, AccountType } from '~/generated/graphql'
import Link from 'next/link'
import { Route } from 'next'
import { getDisplayName } from '~/app/lib/GetAccount'

export function ProBadge() {
  return (
    <Badge color="black" py="0px" px="3px" fz="8px" h="14px" classNames={{ label: proBadgeLabel }}>
      PRO
    </Badge>
  )
}

export function DesktopProfileCard() {
  const { account, navigateToProfile } = useContext(PeerAccountContext)

  const { currentAccount } = useContext(IdentityContext)
  const isCurrentUserProfile = currentAccount?.id === account?.id

  const { isSignedIn } = useAppAuth()

  return (
    <>
      <Link href={`/accounts/${account.id}` as Route} style={{ textDecoration: 'none' }}>
        <Card className={desktopProfileCard} p="0" pt="sm" data-testid="profile-card-desktop">
          <Box className={profileCardCarouselWrapper} onClick={navigateToProfile} my="sm">
            <ImagesCarousel />
          </Box>

          <Flex mx="xs">
            {isSignedIn && !isCurrentUserProfile ? (
              <ConnectButton preset="community" />
            ) : (
              <Button style={{ height: '34px', visibility: 'hidden' }} />
            )}
          </Flex>

          <Card.Section mx="xs" data-testid="profile-card" w="100%" pb="xs" h="100px">
            <Flex align="flex-start">
              <UnstyledButton
                onClick={navigateToProfile}
                className={desktopProfileCardHeader}
                data-testid="profile-card-header"
                w="100%"
              >
                <Flex gap="sm" justify="flex-start" w="100%" mt="sm">
                  <Flex direction="column" gap="4px" align="center">
                    <SafeAvatarImage radius="xs" account={account} />
                    {account.tier === AccountTier.Pro ? <ProBadge /> : null}
                  </Flex>
                  <div className={desktopProfileCardTitle}>
                    <Flex justify="space-between" align="center" w="100%">
                      <Text tt="uppercase" size="13px" fw={600} data-testid="go-to-profile-button">
                        {getDisplayName(account)}
                      </Text>
                      {account.personalDetails?.openToTestShoots ? (
                        <Badge size="xs" color="black" mr="20px">
                          TEST SHOOTS
                        </Badge>
                      ) : null}
                    </Flex>
                    <Flex direction="column" gap="0px" pt="4px">
                      {account.type !== AccountType.Personal ? (
                        <Text size="md" c={'black'} lineClamp={1} pr="md" fw={600} tt="uppercase">
                          {accountType(account)}
                        </Text>
                      ) : null}

                      {account.type === AccountType.Personal &&
                      account.professions &&
                      account.professions.length > 0 ? (
                        <Text size="md" lineClamp={1} pr="md">
                          {accountProfessions(account)}
                        </Text>
                      ) : null}
                      {account.profile?.location ? (
                        <Text size="md" lineClamp={2} pr="md" tt="capitalize">
                          {account.profile?.location}
                        </Text>
                      ) : null}
                    </Flex>
                  </div>
                </Flex>
              </UnstyledButton>
              <Flex direction="column" mr="xs" pr="xs" gap="5px"></Flex>
            </Flex>
          </Card.Section>
        </Card>
      </Link>
    </>
  )
}
